
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// Gestion de la page modules et gestion
require('./components/generator');

require('./components/role');

require('./components/menu');

//ajout d'espace lors du l'entree de numero
require('./components/fournisseur');

// Gestion des pages de commandes
require('./components/commandes');

// Gestion de la reception de commandes
require('./components/reception');

//Gestion de la creation de chef de service user
require('./components/userForm');

//Gestion de la creation/modification enteteService
require('./components/enteteService');

//custom service creation + budget modification
require('./components/service');

// Gestion des bons de commandes
require('./components/bonCommande');

// Gestion du modal de facturation
require('./components/billing');

// Datatable custom
require('./components/dataTable');